/**
 * Return elements of the arr1 that are not included in the arr2
 * Filter elements by id
 *
 * @param {Array} arr1 - Initial array
 * @param {Array} arr2 - Array to compare with
 * @returns {Array} - Array of different elements
 */
export function sortArraysAndReturnNotEqualItems(arr1, arr2) {
  return arr1.filter(({id: id1}) => !arr2.some(({id: id2}) => id2 === id1));
}